import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import nextheralogopreto from '../assets/nextheralogo.png';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <NavWrapper isScrolled={isScrolled}>
      <Nav isScrolled={isScrolled}>
        <NavContent isScrolled={isScrolled}>
          <LogoContainer isScrolled={isScrolled}>
            <LogoImage src={nextheralogopreto} alt="NexThera" isScrolled={isScrolled} />
          </LogoContainer>
          <MenuToggle onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X /> : <Menu />}
          </MenuToggle>
          <NavLinks isOpen={isMenuOpen} isScrolled={isScrolled}>
            <NavItem
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <a href="#about">About</a>
            </NavItem>
            <NavItem
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <a href="#technology">Technology</a>
            </NavItem>
            <NavItem
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <a href="#team">Team</a>
            </NavItem>
            <NavItem
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <a href="#contact">Contact</a>
            </NavItem>
          </NavLinks>
        </NavContent>
      </Nav>
    </NavWrapper>
  );
};

const NavWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  padding: ${props => props.isScrolled ? '10px 20px' : '20px 20px'};
  transition: padding 0.3s ease;
`;

const Nav = styled.nav`
  width: 100%;
  max-width: ${props => props.isScrolled ? '800px' : '1200px'};
  background: ${props => props.isScrolled ? 'rgba(255, 255, 255, 0.95)' : 'transparent'};
  backdrop-filter: ${props => props.isScrolled ? 'blur(20px)' : 'none'};
  border-radius: ${props => props.isScrolled ? '50px' : '0px'};
  border: ${props => props.isScrolled ? '1px solid rgba(255, 255, 255, 0.3)' : 'none'};
  box-shadow: ${props => props.isScrolled ? '0 8px 32px rgba(0, 0, 0, 0.1)' : 'none'};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform: ${props => props.isScrolled ? 'scale(0.95)' : 'scale(1)'};
`;

const NavContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${props => props.isScrolled ? '12px 24px' : '16px 32px'};
  transition: padding 0.3s ease;
  
  @media (max-width: 768px) {
    padding: ${props => props.isScrolled ? '10px 20px' : '16px 20px'};
  }
`;

const LogoContainer = styled.div`
  transition: all 0.3s ease;
`;

const LogoImage = styled.img`
  height: ${props => props.isScrolled ? '50px' : '65px'};
  width: auto;
  transition: height 0.3s ease;
  cursor: pointer;
`;

const MenuToggle = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  color: #2094F1;

  @media (max-width: 768px) {
    display: block;
  }
`;

const NavLinks = styled.ul`
  display: flex;
  gap: ${props => props.isScrolled ? '1.5rem' : '2rem'};
  list-style: none;
  margin: 0;
  padding: 0;
  transition: gap 0.3s ease;

  @media (max-width: 768px) {
    display: ${props => props.isOpen ? 'flex' : 'none'};
    flex-direction: column;
    position: absolute;
    top: calc(100% + 10px);
    left: 20px;
    right: 20px;
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(20px);
    padding: 20px;
    border-radius: 20px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.3);
    gap: 1rem;
  }
`;

const NavItem = styled(motion.li)`
  a {
    color: #4a5568;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.3s ease;

    &:hover {
      color: #2094F1;
    }
  }
`;

export default Navbar;
